import { motion } from "framer-motion";

const DOMAINS = ["Culture", "Family", "Education", "Placement", "Community", "Identity", "Relationships", "Wellbeing"];

export const RadialDiagram = () => {
  return (
    <div data-testid="radial-diagram" className="relative w-full max-w-[540px] aspect-square mx-auto select-none">
      {/* soft rings */}
      <div className="absolute inset-[6%] rounded-full border border-ochre/40" />
      <div className="absolute inset-[22%] rounded-full border border-terracotta/25" />
      <div className="absolute inset-[38%] rounded-full border border-blush" />

      {/* orbiting Aunty */}
      <div className="absolute inset-[6%] animate-spin-slower">
        <div className="absolute left-1/2 -translate-x-1/2 -top-5">
          <div className="animate-[spin-slower_46s_linear_infinite_reverse]">
            <div className="flex items-center gap-2 rounded-full bg-terracotta text-cream px-5 py-2.5 shadow-[0_16px_36px_rgba(192,87,70,0.4)]">
              <span className="h-2 w-2 rounded-full bg-cream animate-pulse" />
              <span className="text-xs font-bold uppercase tracking-widest whitespace-nowrap">Aunty beside them</span>
            </div>
          </div>
        </div>
      </div>

      {/* domain nodes */}
      {DOMAINS.map((d, i) => {
        const angle = (i / DOMAINS.length) * 2 * Math.PI - Math.PI / 2;
        const r = 39;
        const x = 50 + r * Math.cos(angle);
        const y = 50 + r * Math.sin(angle);
        return (
          <motion.div
            key={d}
            initial={{ opacity: 0, scale: 0.6 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15 + i * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="absolute"
            style={{ left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" }}
          >
            <div className="rounded-full bg-cream border border-ochre/40 shadow-[0_10px_24px_rgba(74,55,40,0.10)] px-4 py-2 sm:px-5 sm:py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wider text-earth whitespace-nowrap">
              {d}
            </div>
          </motion.div>
        );
      })}

      {/* centre */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <div className="grain relative overflow-hidden h-32 w-32 sm:h-40 sm:w-40 rounded-full bg-charcoal text-cream flex flex-col items-center justify-center text-center shadow-[0_24px_60px_rgba(45,42,38,0.35)]">
          <span className="font-display italic text-xl sm:text-2xl leading-tight px-4">Young person</span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-ochre mt-1">Knowledge holder</span>
        </div>
      </motion.div>
    </div>
  );
};
